import { render, staticRenderFns } from "./CartAddPersonalGreeting.vue?vue&type=template&id=be279760&"
import script from "./CartAddPersonalGreeting.vue?vue&type=script&lang=js&"
export * from "./CartAddPersonalGreeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports